import api from '@/libs/axiosInstance';
import type { Pagination } from '@/types/pagination';
import type { BulkEmailBatchSummary } from '@fluenceur/types';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

export interface SentBatchesFilters {
  page?: number;
  limit?: number;
  search?: string;
}

export interface SentBatchesResponse {
  meta: Pagination;
  data: BulkEmailBatchSummary[];
}

const fetchSentBatches = async (filters: SentBatchesFilters): Promise<SentBatchesResponse> => {
  const response = await api.get<{ data: SentBatchesResponse }>('/dashboard/messages/sent', {
    params: filters,
  });
  return response.data.data;
};

export const useSentBatchesQuery = (
  filters: SentBatchesFilters = {},
  options?: Pick<UseQueryOptions<SentBatchesResponse, Error>, 'enabled'>
) => {
  return useQuery<SentBatchesResponse, Error>({
    queryKey: ['sentBatches', filters],
    queryFn: () => fetchSentBatches(filters),
    staleTime: 1000 * 60 * 2,
    ...options,
  });
};
